import { QUERY_PARAMS } from 'components/LandingPage.const';
import { SessionStorage } from 'util/Storage';
import { OnlineOrderProviders } from './usePostOrdersRequest';
import { useColoRequest } from './useColoRequest';
import { HOSTNAME, SERVER_PATH_BASIC } from 'olo-service/axiosInstance';
import { OrderReceipt } from 'olo-service';

export function usePostConversionTracking() {
    const sessionProviderType = SessionStorage.tryGetItem(QUERY_PARAMS.utmSource);
    const providerType = sessionProviderType === OnlineOrderProviders.OWG ? OnlineOrderProviders.OWG : OnlineOrderProviders.CWO;
    const rwgToken = SessionStorage.tryGetItem(QUERY_PARAMS.rwgToken);

    const payload = {
        orderId : '',
        rwgToken
    };
    const [, conversionTracking] = useColoRequest(
        (response: OrderReceipt) => rwgToken && providerType === OnlineOrderProviders.OWG && ({
    method: 'POST',
    baseURL: HOSTNAME,
    url: `${SERVER_PATH_BASIC}/conversion-tracking`,
    data: {
        ...payload,
        orderId : response.receiptId,
    },
    }), []);

    return { conversionTracking };
}
